/* Quick-add for SS product cards: adds the card's specific variant to cart via
   AJAX and opens the cart drawer/notification (no page reload). One delegated
   listener handles every card on the page (PLP, carousel, search). */
(function () {
  if (window.__ssQuickAddInit) return;
  window.__ssQuickAddInit = true;

  // Whole-card click → go to the product. Ignore clicks on interactive elements
  // (links, buttons, the add-to-cart form, tiles, inputs) so those still work.
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('.ss-product-card--linked');
    if (!card) return;
    if (e.target.closest('a, button, form, input, select, label, [role="button"], [data-tile], .ss-product-card__cta')) return;
    if (window.getSelection && String(window.getSelection())) return; // don't hijack text selection
    var url = card.getAttribute('data-card-url');
    if (!url) return;
    if (e.metaKey || e.ctrlKey || e.button === 1) { window.open(url, '_blank'); } // cmd/ctrl/middle → new tab
    else { window.location = url; }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.ss-product-card__form');
    if (!form) return;
    e.preventDefault();

    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    var btn = form.querySelector('.ss-product-card__cta');
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: [{ id: Number(idInput.value), quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) { return; } // e.g. sold out / error
        // Match Dawn's native product-form add EXACTLY: publish cartUpdate FIRST so the
        // theme's cart ecosystem (free-samples engine, etc.) reconciles cleanly via the
        // event — then render. Without this publish, free-samples only reacts to our DOM
        // mutation mid-render and races, blanking the drawer items until a page refresh.
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'ss-quick-add',
              productVariantId: Number(idInput.value),
              cartData: data
            });
          }
        } catch (e) {}
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
          if (cart.classList) cart.classList.remove('is-empty');
          if (typeof cart.open === 'function') cart.open();
          else cart.classList && cart.classList.add('active', 'animate');
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { window.location = (window.routes && window.routes.cart_url) || '/cart'; })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); } });
  });
})();
